import form from "./form";


const {
    formField: {
        clubId,
        feeSchedule,
        referralSchedule,
        referredClub
    },
} = form;

const initialValues = {
    [clubId.name]: "",
    [feeSchedule.name]: "",
    [referralSchedule.name]: "",
    [referredClub.name]: ""
};

export default initialValues;
